import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { portalApi, getStoredUser, setSession, clearSession } from "../lib/portalApi";

const PortalAuthContext = createContext(null);

export function PortalAuthProvider({ children }) {
  const [user, setUser] = useState(getStoredUser());
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await portalApi.me();
      setUser(data.user);
      // Keep localStorage in sync (so flags like force_password_change persist on refresh).
      try { localStorage.setItem("tf_portal_user", JSON.stringify(data.user)); } catch { /* ignore */ }
      return data.user;
    } catch {
      clearSession();
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    let active = true;
    refresh().finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    const data = await portalApi.login(email, password);
    setSession(data.token, data.user);
    setUser(data.user);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try { await portalApi.logout(); } catch { /* cookie may already be gone */ }
    clearSession();
    setUser(null);
    window.location.href = "/projects";
  }, []);

  return (
    <PortalAuthContext.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </PortalAuthContext.Provider>
  );
}

export const usePortalAuth = () => {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error("usePortalAuth must be used inside PortalAuthProvider");
  return ctx;
};
